import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { animated } from 'react-spring';

import { darkGreyColor } from 'js/config/style';
import { url } from 'js/services/Network';
import Modal from 'js/components/core/Modal';

import UserDetailsState from 'js/stores/pages/MyAccountPageState/UserDetails';

import Button from '../Button';

import ChangePasswordLink from './ChangePasswordLink';
import Container from './Container';
import UserLogoIcon from './UserLogoIcon';
import Grid from './Grid';
import Label from './Label';
import Text from './Text';
import EditForm from './EditForm';
import userCountry from 'js/services/UserCountry';

@observer
export default class UserDetails extends Component {
  state = UserDetailsState.create({ user: this.props.state });

  render() {
    const state = this.state;
    const { name, login, phone_number, phone_number_formatted, notification_method, email } = state.user;
    const { address1, address2, city, state: addressState, zip, hasAddress } = state.user.address;
    return (
      <>
        <animated.div style={this.props.animation}>
          <Container>
            <div style={{ display: 'grid', alignItems: 'center', justifyContent: 'center', color:'rgb(13, 110, 253)',cursor:'pointer' }}>
              <UserLogoIcon color={darkGreyColor} />
            </div>
            <Grid>
              <Label>Profile</Label>
              <Text bold>@{login}</Text>

              <Label></Label>
              <Text>
                <ChangePasswordLink to={url('change-password-page')}>Change my password</ChangePasswordLink>
              </Text>

              <Label>Name</Label>
              <Text hasValue={!!name} required>
                {name}
              </Text>

              <Label>Email</Label>
              <Text required>{email}</Text>

              <Label>Phone</Label>
              <Text hasValue={!!phone_number} required>
                {userCountry() === 'NG' ? `${phone_number_formatted} (${notification_method === 'sms' ? 'SMS' : 'WhatsApp'})` : phone_number}
              </Text>

              <Label>Address</Label>
              <Text hasValue={!!hasAddress} required>
                <div>
                  {address1}
                  {address2 && `, ${address2}`}
                </div>
                <div>
                  {city} {addressState}, {zip}
                </div>
              </Text>
            </Grid>
            <Button onClick={state.showModal}>Edit</Button>
          </Container>
        </animated.div>

        <Modal showModal={state.modalIsVisible} onCancel={state.closeModal} withCloseButton>
          <EditForm state={state} />
        </Modal>
      </>
    );
  }
}
